angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.ObjectPickerHierarchyViewController', [
	'mx.SolutionBuilderAgent.Http',
	'$scope',
	'$q',
	'$timeout',
	function mxObjectPickerHierarchyViewController(http, $scope, $q, $timeout) {
		const vm = this;

		vm.tree = [];

		vm.loaded = false;

		vm.$onInit = function () {
			loadHierarchy();
		};

		vm.selectedNodeId = null;
		vm.selectedNode = null;

		vm.findNodeById = findNodeById;

		$scope.$watch('vm.selectedNodeId', function (newN, oldN) {
			if (newN) {
				if (newN !== oldN) {
					vm.selectedNode = findNodeById(vm.tree, newN);
					closeAllTree(vm.tree);
					highlightNodeInTree(vm.tree, vm.selectedNode);
				}
			} else {
				closeAllTree(vm.tree);
				// eslint-disable-next-line angular/controller-as
				$scope.__treeLevel = vm.tree;
			}
		});

		vm.expandNode = function (node) {
			node._expanded = !node._expanded;
		};

		vm.select = function (node) {
			vm.finishDefer.resolve(node);
		};

		vm.cancel = function () {
			vm.finishDefer.reject(mx.noLogCatchMessage('hierarchy view was canceled'));
		};

		vm.onSearchReset = function () {
			vm.searchText = '';
		};

		vm.loadTreeBySearchText = function (searchText, id, parentId) {
			searchText = searchText && searchText.split('%').join(' ');
			let resTree = parentId ? [findNodeById(vm.tree, parentId)] : vm.tree;
			const parents = resTree[0].__parents;
			let i, closestParentClone;
			if (parents && parents.length) {
				for (i = parents.length - 1; i >= 0; i--) {
					closestParentClone = $.extend({}, parents[i]);
					closestParentClone.children = resTree;
					resTree = [closestParentClone];
				}
			}
			return $q.when(resTree);
		};

		function getParameter(parameter) {
			return vm[parameter] || vm.__view.locals[parameter];
		}

		function loadHierarchy() {
			const options = {
				entityClass: vm.entityClassName,
				parentExpression: getParameter('parentExpression'),
				displayExpression: getParameter('displayExpression'),
				rootElement: getParameter('rootElement'),
				includeRoot: getParameter('includeRoot'),
				dataQueryName: getParameter('dataQueryName'),
			};

			const requestFilter = getParameter('filter')?.toRequest() || {};

			if ('WhereExpression' in requestFilter) {
				requestFilter.filter = requestFilter.WhereExpression;
				delete requestFilter.WhereExpression;
			}

			http.post('api/entity/tree', { ...options, ...requestFilter }).then((res) => prepareTree(res));
		}

		function prepareTree(res) {
			vm.tree = prepareData(res);
			vm.loaded = true;
			if (vm.selectedId) {
				vm.selectedNodeId = vm.selectedId;
				$timeout(function () {
					highlightNodeInTree(vm.tree, findNodeById(vm.tree, vm.selectedId));
				});
			}
			// eslint-disable-next-line angular/controller-as
			$scope.__treeLevel = vm.tree;
			return vm.tree;
		}
	},
]);

function prepareData(dirtyTree) {
	return dirtyTree.map(function (n) {
		n.id = n.Id;
		n.title = n.DisplayString;
		if (n.Chidren) {
			n.children = prepareData(n.Chidren);
			delete n.Chidren;
		}
		return n;
	});
}

function findNodeById(tree, id) {
	let res = null;
	tree.forEach(function (node) {
		if (!res) {
			if (node.id === id) {
				res = node;
			} else if (node.children && node.children.length) {
				res = findNodeById(node.children, id);
			}
		}
	});
	return res;
}

function highlightNodeInTree(tree, selectedNode) {
	const parents = selectedNode.__parents;
	let nodesChain = [];
	if (parents && parents.length) {
		nodesChain = nodesChain.concat(parents);
	}
	nodesChain.push(selectedNode);
	let level = tree;
	let subLevel;
	nodesChain.forEach(function (n) {
		if (level) {
			level.forEach(function (li) {
				if (li.id === n.id) {
					li._highlighted = true;
					if (li.children) {
						li._expanded = true;
						subLevel = li.children;
					}
				}
			});
		}
		level = subLevel;
		subLevel = undefined;
	});
}

function closeAllTree(tree) {
	tree.forEach(function (n) {
		n._highlighted = false;
		if (n.children) {
			n._expanded = false;
			closeAllTree(n.children);
		}
	});
}
